/**
 * Returns the next upcoming occurrence of the given month (1-12) and day as "YYYY-MM-DD".
 * If that date hasn't passed yet this year, returns this year's date.
 * Otherwise returns next year's date.
 */
export function nextSeasonDate(month: number, day: number): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // compare dates only, ignore current time
  const thisYear = today.getFullYear();

  const thisYearDate = new Date(thisYear, month - 1, day);
  const targetYear = thisYearDate >= today ? thisYear : thisYear + 1;

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${targetYear}-${pad(month)}-${pad(day)}`;
}
